import { Authentication } from './../../models/authentication.model';
import { SignIn } from './../../models/sign-in.model';
import talentApi from "./talent-api-config";
import talentNoAuthApi from "./talent-api-noauth-config";

class AuthenticationApi {

    async sendMagicLink(signIn: SignIn): Promise<void> {
        return talentApi.post(`/talent/${signIn.event}/signin/`, { email: signIn.email });
    }

    async authenticate(authentication: Authentication) {
        const queryParams = { url_auth_token: authentication.tokenKey };
        return talentApi.get<{ token: string }>(`/talent/${authentication.event}/signin/`, { params: queryParams });
    }

    async setupCompleted() {
        return talentApi.post(`/users/setup/talent/ `, { });
    }

    async getUser() {
        return talentApi.get(`/users/talent/`);
    }

    async updateTermAccept() {
        return talentApi.patch(`/users/accept-term-talent/`);
    };

    async talentToken(user_id: string, email?: string) {
        return talentApi.post(`/users/${user_id}/talent-token/`, { email });
    }
    
    async talent_validate_email(user_id: string, token: string) {
        return talentNoAuthApi.get(`/users/${user_id}/talent/validate-email/${token}/`);
    };
}

export const authenticationApi = new AuthenticationApi();
